export const PagePlaceholder = () => (
    <div className="placeholder-glow">
        <div className="placeholder placeholder-lg col-12"></div>
    </div>
);
